module.exports = __webpack_public_path__ + "res/27-img_x.78280b5b93b1457f17d9b457ca1a0c51.png";